import {Main} from '../../components/main/main.tsx';
import {Avatar} from '../../components/avatar/avatar.tsx';
import {Page} from '../../components/page/page.tsx';
import {useAppSelector} from '../../store/store.ts';
import {CustomerFieldKeys, getValue} from '../../support/get_data.ts';
import {CardGrid} from '../../components/card/card_grid.tsx';
import {Status} from '../../enums/status.ts';
import {CenteredSpinner} from '../../components/spinner/centered_spinner.tsx';
import {AltButton} from '../../components/button/alt_button.tsx';
import {__} from '../../support/lang/translations.ts';
import {PageTitle} from '../../components/page/page_title.tsx';
import {PageContent} from '../../components/page/page_content.tsx';
import {VehicleCard} from '../../components/vehicle/vehicle_card.tsx';
import {VehiclePlaceholder} from '../../components/vehicle/vehicle_placeholder.tsx';
import {useState} from 'react';
import {CreateVehicleModal} from '../../components/vehicle/create_vehicle_modal.tsx';
import {HideElement} from '../../components/utility/hide_element_wrapper.tsx';
import {ShowElement} from '../../components/utility/show_element_wrapper.tsx';

export function Vehicles() {
    const customerInfo = useAppSelector((state) => state.customerInfo);
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    const nameData = getValue(meData, CustomerFieldKeys.NAME);
    const prepositionData = getValue(meData, CustomerFieldKeys.PREPOSITION);
    const surNameData = getValue(meData, CustomerFieldKeys.SURNAME);

    const [isCreateVehicleModalOpen, setIsCreateVehicleModalOpen] = useState(false);

    if (customerInfo.status !== Status.FULFILLED) {
        return <CenteredSpinner />;
    }

    const fullName = [nameData?.value, prepositionData?.value, surNameData?.value]
        .filter((part) => part && part?.length > 0)
        .join(' ');
    const vehicles = customerInfo.me?.customer?.vehicles;

    return (
        <Main>
            {isCreateVehicleModalOpen && (
                <CreateVehicleModal onCloseModal={() => setIsCreateVehicleModalOpen(false)} vehicles={vehicles} />
            )}
            <Page>
                <PageContent style={{paddingBottom: 0}}>
                    <Avatar name={fullName} src={meData?.profilePicture?.signed_url} />
                </PageContent>
                <PageContent style={{paddingBottom: 0}}>
                    <ShowElement size={'sm'}>
                        <PageTitle>
                            <h2>{__('vehicles.titles.index')}</h2>
                            <AltButton onClick={() => setIsCreateVehicleModalOpen(true)} className="ml-auto">
                                <i className="fa-light fa-plus" />
                            </AltButton>
                        </PageTitle>
                    </ShowElement>
                    <HideElement size={'sm'}>
                        <PageTitle>
                            <h2 className="mr-auto">{__('vehicles.titles.index')}</h2>
                            <AltButton onClick={() => setIsCreateVehicleModalOpen(true)}>
                                <i className="fa-light fa-plus" />
                                {__('vehicles.buttons.add')}
                            </AltButton>
                        </PageTitle>
                    </HideElement>

                    <CardGrid columns={2}>
                        {vehicles?.map((vehicle, index) => {
                            if (!vehicle) {
                                return null;
                            }
                            return <VehicleCard vehicle={vehicle} key={`${vehicle.id}-${index}`} />;
                        })}

                        {vehicles?.length === 0 && (
                            <>
                                <VehiclePlaceholder style={{opacity: 0.7}} />
                                <VehiclePlaceholder style={{opacity: 0.5}} />
                            </>
                        )}
                    </CardGrid>
                </PageContent>
            </Page>
        </Main>
    );
}
